import createModel, { prop } from './lib/create_model';

const Action = createModel({
  modelName: 'Action',

  properties: {
    actionAdapterId: prop(String),
    guardrails: prop([Object]),
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

const CyberThreadComponent = createModel({
  modelName: 'CyberThreadComponent',

  properties: {
    id: prop(String),
    name: prop(String),
    guidance: prop(String),
    guidanceHtml: prop(String),
    action: prop(Action),
    choices: prop([String]),
    nextComponentId: prop(String),
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

const Guardrail = createModel({
  modelName: 'Guardrail',

  properties: {
    id: prop(String),
    name: prop(String),
    type: prop(String),
    condition: prop(Object),
    nextComponentId: prop(String),
    guidance: prop(String),
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

const GuardrailResult = createModel({
  modelName: 'GuardrailResult',

  properties: {
    success: prop(Boolean),
    guardrail: prop(Guardrail),
    component: prop(CyberThreadComponent),
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

const AICyberThreadsGuardrailResult = createModel({
  modelName: 'AICyberThreadsGuardrailResult',

  properties: {
    result: prop(GuardrailResult),
    isSkipped: prop(Boolean),
    causedByItemIds: prop([String]),
    guideType: prop(String),
    guideId: prop(String),
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default AICyberThreadsGuardrailResult;
